const ss = {
    title: 'SketchScope: Basic',
    about: '시범콘텐츠 중 ‘미라의 머리 속은 어떻게 생겼을까?’ 에 활용된 기술로 볼륨렌더링된 물체에 스케치를 통하여 위젯을 생성하고 이를 조절하여 원하는대로 내부구조를 확인할 수 있는 기술입니다.\n기술적인 설명은 아래 논문을 참고하여 주시길 바랍니다.',
    paperlink: 'https://www.dbpia.co.kr/journal/articleDetail?nodeId=NODE10441923',
    interface: '미정',
    updates: 'SketchScope에 대한 기본적인 설명과 각 디바이스를 이용하여 SketchScope를 활용하는 방법을 아래 영상으로 확인할 수 있습니다. \n' +
            '기본적으로 볼륨을 가르는 Create Mode, 물체의 갈라진 정도를 조정할 수 있는 Modify Mode, 그리고 볼륨을 회전시키는 Rotate Mode로 구성되어 있습니다.\n' ,
    demo: '@/assets/sketchscope.png'
}

export {ss}